import { createReducer, on } from '@ngrx/store';
import { initialState } from './data-access.state';
import * as CaseDetailsActions from './data-access.actions';
import { ActionType, CaseDetailsActionResult } from '../models/case-action-result.models';

export const caseDetailsReducer = createReducer(
  initialState,

  on(CaseDetailsActions.clearState, () => {
    return {
      ...initialState,
    };
  }),
  on(CaseDetailsActions.fetchCaseDetails, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(CaseDetailsActions.fetchCaseDetailsSuccess, (state, payload) => {
    return {
      ...state,
      caseUid: payload.caseDetails.uid,
      caseDetails: payload.caseDetails,
      isLoading: false,
    };
  }),
  on(CaseDetailsActions.fetchCaseEvidenceFiles, (state) => {
    return {
      ...state,
      evidenceFilesLoading: true,
    };
  }),
  on(CaseDetailsActions.fetchCaseEvidenceFolders, (state) => {
    return {
      ...state,
      evidenceFoldersLoading: true,
    };
  }),
  on(CaseDetailsActions.fetchCaseEvidenceFilesSuccess, (state, payload) => {
    return {
      ...state,
      evidenceFiles: payload.evidenceFiles,
      evidenceFilesLoading: false,
    };
  }),
  on(CaseDetailsActions.fetchCaseEvidenceFoldersSuccess, (state, payload) => {
    return {
      ...state,
      evidenceFolders: payload.evidenceFolders,
      evidenceFoldersLoading: false,
    };
  }),
  on(CaseDetailsActions.addFolderSuccess, (state, payload) => {
    if (state.evidenceFolders) {
      return {
        ...state,
        evidenceFolders: state.evidenceFolders.concat(payload.folder),
        actionResult: new CaseDetailsActionResult(ActionType.AddFolder, null, true),
      };
    }

    return state;
  }),
  on(CaseDetailsActions.addEvidenceFileSuccess, (state, payload) => {
    if (state.evidenceFiles) {
      return {
        ...state,
        evidenceFiles: state.evidenceFiles.concat(payload.evidence),
      };
    }

    return state;
  }),
  on(CaseDetailsActions.updateCase, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(CaseDetailsActions.updateCaseSuccess, (state, payload) => {
    return {
      ...state,
      caseUid: payload.updatedCaseDetails.uid,
      caseDetails: payload.updatedCaseDetails,
      actionResult: new CaseDetailsActionResult(ActionType.UpdateCaseDetails, null, true),
      isLoading: false,
    };
  }),
  on(CaseDetailsActions.moveEvidenceFileToFolderSuccess, (state, payload) => {
    if (state.evidenceFiles) {
      return {
        ...state,
        evidenceFiles: state.evidenceFiles.map((file) => {
          const fileCopy = { ...file };
          if (fileCopy.uid === payload.movedFileUid) {
            fileCopy.caseFolder = payload.destinationFolder;
          }

          return fileCopy;
        }),
      };
    }

    return state;
  }),
  on(CaseDetailsActions.deleteFolderSuccess, (state, payload) => {
    if (state.evidenceFiles && state.evidenceFolders) {
      return {
        ...state,
        evidenceFiles: state.evidenceFiles.map((file) => {
          const fileCopy = { ...file };
          if (file.caseFolder?.uid === payload.folderUid) {
            fileCopy.caseFolder = null;
          }

          return fileCopy;
        }),
        evidenceFolders: state.evidenceFolders.filter((folder) => folder.uid !== payload.folderUid),
      };
    }

    return state;
  }),
  on(CaseDetailsActions.removeEvidence, (state) => {
    return {
      ...state,
      evidenceFilesLoading: true,
    };
  }),
  on(CaseDetailsActions.removeEvidenceFailure, (state) => {
    return {
      ...state,
      evidenceFilesLoading: false,
    };
  }),
  on(CaseDetailsActions.removeEvidenceSuccess, (state, payload) => {
    if (state.evidenceFiles) {
      return {
        ...state,
        evidenceFiles: state.evidenceFiles.filter((x) => x.uid !== payload.evidenceUid),
        evidenceFilesLoading: false,
      };
    }

    return state;
  }),
  on(CaseDetailsActions.updateOfficerCaseRole, (state, payload) => {
    if (state.caseDetails && payload.role) {
      return {
        ...state,
        caseDetails: {
          ...state.caseDetails,
          officerCaseRole: payload.role,
        },
      };
    }

    return state;
  }),
  on(CaseDetailsActions.fetchCaseMembers, (state) => {
    return {
      ...state,
      caseMembersLoading: true,
    };
  }),
  on(CaseDetailsActions.fetchCaseMembersSuccess, (state, payload) => {
    return {
      ...state,
      caseMembers: payload.caseMembers,
      caseMembersLoading: false,
    };
  }),
  on(CaseDetailsActions.addCaseMember, (state) => {
    return {
      ...state,
      caseMembersLoading: true,
    };
  }),
  on(CaseDetailsActions.addCaseMemberFailure, (state) => {
    return {
      ...state,
      caseMembersLoading: false,
    };
  }),
  on(CaseDetailsActions.addCaseMemberSuccess, (state, payload) => {
    return {
      ...state,
      caseMembersLoading: false,
      caseMembers: state.caseMembers.concat(payload.member),
    };
  }),
  on(CaseDetailsActions.removeMember, (state) => {
    return {
      ...state,
      caseMembersLoading: true,
    };
  }),
  on(CaseDetailsActions.removeMemberSuccess, (state, payload) => {
    return {
      ...state,
      caseMembersLoading: false,
      caseMembers: state.caseMembers.filter((x) => x.uid !== payload.memberUid),
    };
  }),
  on(CaseDetailsActions.updateCaseMember, (state) => {
    return {
      ...state,
      caseMembersLoading: true,
    };
  }),
  on(CaseDetailsActions.updateCaseMemberSuccess, (state, payload) => {
    return {
      ...state,
      caseMembersLoading: false,
      caseMembers: state.caseMembers.map((x) => (x.uid !== payload.member.uid ? x : { ...x, role: payload.role })),
    };
  }),
  on(CaseDetailsActions.updateCaseDetailsActionResult, (state, { actionResult }) => {
    return {
      ...state,
      actionResult: actionResult,
      isLoading: false,
    };
  })
);
